const isDev = process.env.NODE_ENV === 'development'
const devUrl =  process.env.REACT_APP_API_URL_DEV
const prodUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001'

export const baseUrl = isDev ? devUrl : prodUrl
console.log('isDev',isDev,baseUrl)

export const endpoints = {
  // Auth endpoints
  sendOTP: '/api/auth/send-otp',
  verifyOTP: '/api/auth/verify-otp',
  completeProfile: '/api/auth/complete-profile',
  acceptTerms: '/api/auth/accept-terms',
  declineTerms: '/api/auth/decline-terms',
  refreshToken: '/api/auth/refresh-token',
  logout: '/api/auth/logout',
  getMe: '/api/auth/me',
  updateProfile: '/api/auth/profile',
  googleLogin: '/api/auth/google-login',
  googleSignup: '/api/auth/google-signup',
  adminLogin: '/api/auth/admin/login',
  sendEmailVerification: '/api/auth/send-email-verification',
  verifyEmail: '/api/auth/verify-email',

  // Superadmin: staff account management
  createStaffUser: '/api/auth/admin/staff',
  getStaffUsers: '/api/auth/admin/staff',
  updateStaffStatus: '/api/auth/admin/staff/:id/status',

  // Book endpoints
  createBook: '/api/books',
  getBooks: '/api/books',
  getBook: '/api/books/:id',
  updateBook: '/api/books/:id',
  deleteBook: '/api/books/:id',
  submitBook: '/api/books/:id/submit',
  switchToPdf: '/api/books/:id/switch-to-pdf',
  verifyBook: '/api/books/:id/verify',
  getVerifyStatus: '/api/books/:id/verify-status',
  initiatePdfImport: '/api/books/:id/pdf-import',
  getPdfImportStatus: '/api/books/:id/pdf-import-status',
  resizePdf: '/api/books/:id/resize-pdf',
  cloneBook: '/api/books/:id/clone',
  updateBookStep: '/api/books/:id/step',
  updatePageCount: '/api/books/:id/page-count',
  approvePageCount: '/api/books/:id/approve-page-count',
  removeCoverImage: '/api/books/:id/cover',
  removeUploadedFile: '/api/books/:id/uploaded-file',
  downloadMyBookPDF: '/api/books/:id/my-pdf',

  // Admin book endpoints
  adminDeleteBook:        '/api/books/admin/:id',
  adminUpdateISBN:        '/api/books/:id/isbn',
  adminRegeneratePDF:     '/api/books/admin/:id/regenerate-pdf',
  getAllBooks: '/api/books/admin/all',
  getSubmittedBooks: '/api/books/admin/all?status=submitted',
  getAdminBookDetail: '/api/books/admin/:id',
  reviewBook: '/api/books/:id/review',
  reviewVersion: '/api/books/:id/versions/:versionId/review',
  downloadVersionPDF: '/api/books/:id/versions/:versionId/pdf',

  // File endpoints
  uploadFile: '/api/files/upload',
  tiptapImageCallback: '/api/files/tiptap-image-callback',
  getFiles: '/api/files',
  getFile: '/api/files/:id',
  deleteFile: '/api/files/:id',
  downloadFile: '/api/files/:id/download',
  downloadFileByFilename: '/api/files/download/:filename',

  // PDF endpoints (Puppeteer)
  generatePDF: '/api/pdf/generate',
  previewPDF: '/api/pdf/preview',

  // PDF endpoints (react-pdf - legacy parity)
  reactPdfGenerate: '/api/pdf/react-pdf/generate',
  reactPdfPreview: '/api/pdf/react-pdf/preview',

  // Grammar check
  grammarCheck: '/api/grammar/check',

  // Support endpoints
  createSupportTicket: '/api/support',
  getMyTickets: '/api/support',
  getAllSupportTickets: '/api/support/admin/all',
  resolveSupportTicket: '/api/support/admin/:id/resolve',
  reopenSupportTicket: '/api/support/admin/:id/reopen',

  // Admin user endpoints
  adminGetUsers: '/api/users/admin/list',

  // Admin analytics endpoints
  adminGetFunnel:          '/api/analytics/admin/funnel',
  adminGetWizardDropoff:   '/api/analytics/admin/wizard-dropoff',
  adminGetReEngagement:    '/api/analytics/admin/re-engagement',
  adminGetAddonAdoption:   '/api/analytics/admin/addon-adoption',

  // AI cover generation & designer state persistence
  generateAICover:             '/api/covers/generate-ai',
  saveDesignerState:           '/api/covers/designer-state',
  getDesignerState:            '/api/covers/designer-state/:bookId',
  adminResetBookGenerations:   '/api/covers/admin/reset-generations/:bookId',

  // Feedback
  submitFeedback: '/api/feedback',
  adminGetFeedback: '/api/feedback/admin/all',

  // Sales endpoints
  getSalesLeads: '/api/sales/leads',
  updateSalesContact: '/api/sales/books/:bookId/contact',
  getSalesContactHistory: '/api/sales/books/:bookId/contact-history',

  // Health check
  health: '/health'
}